// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9568":"802d4790","9906":"802d4790"}[chunkId] + ".chunk.css";
};